export { default } from './UserAdd'


// WEBPACK FOOTER //
// ./src/scenes/Administration/User/UserAdd/index.js